import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import date from 'date-and-time'
import './Card.sass'
import { allowJoinClass } from '../../App/Course/Helpers/Timings'
import Button from '../Buttons/Button'
import Rating from '../Rating/Rating'
import { Subscribe } from 'unstated'
import DocumentsViewerStore from '../../Modules/Documents/Viewer/Store/DocumentsViewerStore'
import { getRecording } from '../../API/Course'
import { notify } from '../../Helpers/Notifications'

const ClassCard = ({
  index,
  totalClasses,
  start,
  end,
  rating,
  status,
  userType,
  initiateReschedule,
  recordingId,
  classId,
  batchId,
}) => {
  const [value, set] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const timer = setInterval(() => {
      set(!value)
    }, 1000)

    return () => clearInterval(timer)
  }, [value])

  const deactivated =
    status === 'CANCELLED' || new Date().getTime() > end.getTime()

  const type = (() => {
    let type = ''
    if (status === 'CANCELLED') {
      type = 'RESCHEDULED'
    } else if (status === 'MAKEUP') {
      type = 'MAKE UP CLASS'
    } else if (status === 'MISSED') {
      type = 'MISSED CLASS'
    } else if (new Date().getTime() > end.getTime()) {
      type = 'CLASS OVER'
    }
    return type
  })()
  const currentDate = new Date()

  return (
    <div
      className={'classCard' + (deactivated ? ' deactivated' : '')}
      style={{
        pointerEvents:
          deactivated && status !== 'MISSED' && !recordingId ? 'none' : 'auto',
      }}
    >
      {userType === 'teacher' &&
        !(deactivated && status !== 'MISSED') &&
        status !== 'MAKEUP' && (
          <div className='reschedulePopup' onClick={() => initiateReschedule()}>
            <p>Reschedule </p>
          </div>
        )}

      <h1 style={{ opacity: index + 1 ? 1 : 0 }}>
        Class {index + 1} of {totalClasses}
      </h1>
      <div className='row'>
        <div className='info'>
          <p className='date'>
            {date.format(start, ' DD MMMM YYYY')}{' '}
            <span>({date.format(start, 'dddd')})</span>
          </p>
          <p className='duration'>
            {date.format(start, 'h:mm A')} - {date.format(end, 'h:mm A')}
          </p>
        </div>
        <div className='status'>
          {allowJoinClass(start.getTime()) && !deactivated ? (
            <Link to={'/classroom'}>
              <Button
                onClick={() => {}}
                name={'Join Now'}
                type={'primary big'}
              />
            </Link>
          ) : (
            <p>{type}</p>
          )}
        </div>
        <Subscribe to={[DocumentsViewerStore]}>
          {({ openDocument }) =>
            !!recordingId &&
            !!batchId && (
              <Button
                onClick={async () => {
                  setLoading(true)
                  const data = await getRecording(batchId, classId)
                  setLoading(false)
                  if (data?.otp) {
                    openDocument({
                      name: `Class ${index + 1} Recording`,
                      type: 'protected-video',
                      otp: data.otp,
                      playbackInfo: data.playbackInfo,
                    })
                  } else {
                    notify('error', data)
                  }
                }}
                name={
                  date.addMonths(end, 6) <= currentDate
                    ? 'Recording Expired'
                    : 'View Recording'
                }
                type='primary'
                disabled={loading || date.addMonths(end, 6) <= currentDate}
                loading={loading}
                className='recordingBtn'
              />
            )
          }
        </Subscribe>
      </div>
      {!!rating && <Rating value={rating} inputMode={false} />}
    </div>
  )
}

ClassCard.propTypes = {
  index: PropTypes.number.isRequired,
  totalClasses: PropTypes.number.isRequired,
  start: PropTypes.instanceOf(Date).isRequired,
  end: PropTypes.instanceOf(Date).isRequired,
  // type: PropTypes.oneOf([
  //   "cancelled",
  //   "next",
  //   "rescheduled",
  //   "makeup",
  //   "normal"
  // ]).isRequired
}

export default ClassCard
